import Ajv from "ajv";

import {
  CURRENT_VIZ_SCHEMA_VERSION,
  vizSchema,
} from "@/shared/state/visualization/schema";

export const schemaValidator = new Ajv();

schemaValidator.addSchema(vizSchema, CURRENT_VIZ_SCHEMA_VERSION);
